import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// The web SPA authenticates via the httpOnly `gi_session` cookie that the
// backend sets on /auth/login + /auth/register. `withCredentials: true`
// forwards it on every request. No token is read/written from JS land for the
// web — that was a legacy artefact, removed in May-2026 hardening.
//
// The React Native mobile shell uses Bearer auth via `expo-secure-store`,
// which is its own runtime and does NOT share JS state with this bundle.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      // Public/anonymous pages must not redirect to /login on a 401 from
      // /api/auth/me — they're meant to be reachable without a session.
      const PUBLIC_PATHS = [
        "/", "/login", "/register",
        "/forgot-password", "/reset-password",
        "/appeal", "/gdpr", "/trust", "/auth/callback",
        // Marketing / policy pages — public, no session required.
        "/about", "/privacy", "/terms",
        "/incident-review", "/dispute-resolution",
        "/data-retention", "/compliance-framework",
      ];
      const PUBLIC_PREFIXES = ["/badge/"];
      const isPublic = PUBLIC_PATHS.some((p) => path === p || path.startsWith(`${p}?`) || path.startsWith(`${p}#`))
        || PUBLIC_PREFIXES.some((p) => path.startsWith(p));
      if (!isPublic) {
        window.location.href = `${process.env.REACT_APP_APP_URL || ""}/login`;
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d === "object" && typeof d.msg === "string") return d.msg;
  return String(d);
}
